import { CustomError } from 'ts-custom-error';

export class OnBoardingError extends CustomError {
  statusCode: number;

  constructor(message: string, statusCode = 400) {
    super(message);
    this.statusCode = statusCode;

    // Set name explicitly as minification can mangle class names
    Object.defineProperty(this, 'name', { value: 'OnBoardingError' });
  }
}
